export default __webpack_public_path__ + "assets/images/203ea2145a8c2b232879f1fd6000e06a.png";